import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SystemAiFunction from './system-ai-function';
import SystemAiFunctionDetail from './system-ai-function-detail';
import SystemAiFunctionUpdate from './system-ai-function-update';
import SystemAiFunctionDeleteDialog from './system-ai-function-delete-dialog';

const SystemAiFunctionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SystemAiFunction />} />
    <Route path="new" element={<SystemAiFunctionUpdate />} />
    <Route path=":id">
      <Route index element={<SystemAiFunctionDetail />} />
      <Route path="edit" element={<SystemAiFunctionUpdate />} />
      <Route path="delete" element={<SystemAiFunctionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SystemAiFunctionRoutes;
